import React from "react";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import RemoveProfilePhoto from "./RemoveProfilePhoto";
import UseToggle from "../../Hooks/UseToggle";

const EditYourProfile = ({ Show, Hide, Title }) => {
  const toggles = UseToggle();

  return (
    <>
      <Modal show={Show} onHide={Hide}>
        <Modal.Header closeButton>
          <Modal.Title
            className="fw-bold hstack gap-2"
            style={{ fontSize: 15 }}
          >
            <span>{Title}</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Container>
            <Row>
              <Form.Group as={Col} md={8} className="p-0">
                <Form.Group className="mb-2 section-title d-block">
                  <Form.Label className="mb-1 fw-bold hstack gap-2">
                    Full Name
                  </Form.Label>
                  <Form.Control
                    style={{ fontSize: 12 }}
                    type="text"
                    placeholder="Your Name"
                  />
                </Form.Group>
                <Form.Group className="mb-2 section-title d-block">
                  <Form.Label className="mb-1 fw-bold hstack gap-2">
                    Display Name
                  </Form.Label>
                  <Form.Control
                    style={{ fontSize: 12 }}
                    type="text"
                    placeholder="Display Name"
                  />
                  <Form.Text>
                    This could be your first name, or a nickname — however you’d
                    like people to refer to you in workbridge.
                  </Form.Text>
                </Form.Group>
                <Form.Group className="mb-2 section-title d-block">
                  <Form.Label className="mb-1 fw-bold hstack gap-2">
                    Designation
                  </Form.Label>
                  <Form.Control
                    style={{ fontSize: 12 }}
                    type="text"
                    placeholder="Title"
                  />
                  <Form.Text>
                    Let people know what you do at Devxware.
                  </Form.Text>
                </Form.Group>
              </Form.Group>
              <Form.Group as={Col} md={4} className="pe-0">
                <Form.Group className="mb-2 section-title d-block">
                  <Form.Label className="mb-1 fw-bold hstack gap-2">
                    Profile photo
                  </Form.Label>
                  <div className="mb-2 text-center">
                    <img
                      src="https://i.pravatar.cc/40"
                      className="rounded-1 w-100"
                      alt="profile"
                      style={{ height: 150 }}
                    />
                  </div>
                  <Button
                    className="w-100 p-1 rounded-1 hstack gap-2 justify-content-center"
                    style={{ fontSize: 13 }}
                    variant="outline-primary"
                  >
                    Upload Photo
                  </Button>
                  <p
                    className="text-danger text-center CP"
                    title="Remove Photo"
                    onClick={() => {
                      toggles.setToggle();
                      Hide();
                    }}
                  >
                    Remove Photo
                  </p>
                </Form.Group>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} md={6} className="mb-2 section-title d-block ps-0">
                <Form.Label className="mb-1 fw-bold hstack gap-2">
                  Phone
                </Form.Label>
                <Form.Control
                  style={{ fontSize: 12 }}
                  type="phone"
                  placeholder="Phone"
                />
              </Form.Group>
              <Form.Group as={Col} md={6} className="mb-2 section-title d-block pe-0">
                <Form.Label className="mb-1 fw-bold hstack gap-2">
                  Date of Birth
                </Form.Label>
                <Form.Control
                  style={{ fontSize: 12 }}
                  type="date"
                />
              </Form.Group>
            </Row>
          </Container>
          <Form.Group className="mb-2 section-title d-block">
            <Form.Label className="mb-1 fw-bold hstack gap-2">
              About
            </Form.Label>
            <Form.Control
              style={{ fontSize: 12 }}
              as="textarea"
              placeholder="Enter About"
            />
          </Form.Group>
          <Form.Group className="mb-2 section-title d-block">
            <Form.Label className="mb-1 fw-bold hstack gap-2">
              Time zone
            </Form.Label>
            <Form.Select style={{ fontSize: 12 }}>
              <option>Select Zone</option>
            </Form.Select>
            <Form.Text>
              Your current time zone. Used to send summary and notification
              emails, for times in your activity feeds, and for reminders.
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="text-end">
          <Button
            className="py-1 px-3 rounded-1"
            style={{ fontSize: 13 }}
            variant="outline-primary"
            onClick={Hide}
          >
            Cancel
          </Button>
          <Button
            className="py-1 px-3 rounded-1"
            style={{ fontSize: 13 }}
            variant="primary"
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
      <RemoveProfilePhoto
        onShow={!toggles.toggle}
        onHide={toggles.setToggle}
        Title="Remove Profile Photo"
      />
    </>
  );
};

export default EditYourProfile;
